<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Hex Text Converter</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs6>
            <v-textarea placeholder="Paste your text here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="textToHex()">Text to hex</v-btn>
            <v-btn color="primary" @click="hexToText()">Hex to text</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    text: '',
    result: ''
  }),
  methods: {
    textToHex() {
      let text = unescape(encodeURIComponent(this.text))
      let hex = ''
      for (let i = 0; i < text.length; i++) {
        hex += text.charCodeAt(i).toString(16)
      }
      this.result = hex
    },
    hexToText() {
      this.result = new Buffer(this.text, 'hex').toString()
    }
  }
}
</script>

<style>
</style>